import React from 'react';

import SupplierOrderAccordion from "./SupplierOrderAccordion";

const SupplierOrderCard = ({ order }) => {
  const orderDate = new Date(order.created_at).toLocaleDateString('fa-IR');

  return (
    <div className="border border-gray-200 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-4 bg-white">
      {/* Accordion for details */}
        <SupplierOrderAccordion order={order} />

    </div>
  );
};

export default SupplierOrderCard;
